import React from 'react';

const ConditionIcon = (props) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <img
      src={props.icon}
      style={{
        width: '47px',
        height: '37.5px',
      }}
      alt="icon"
    />
    <p
      style={{
        color: '#515151',
        fontFamily: 'var(--font-secondary)',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '23px',
        marginTop: '10px',
        textAlign: 'center',
      }}
    >
      {props.condition}
    </p>
  </div>
);

export default ConditionIcon;
